import React from 'react';
import { Card, CardTitle } from 'reactstrap';
import SelectedDropdown from './SelectedDropdown/SelectedDropdown';
import MemberSelector from './MemberSelector/MemberSelector';

import './DimensionBox.scss';

/**
 * Contains one dimension and its members for selection
 * @param       {Object}   dimension           dimension data
 * @param       {Function} setMemberSelection  changes member's active property
 * @constructor
 */
function DimensionBox({ dimension, setMemberSelection }) {
  return (
    <Card body className="dim-box mt-3">
      <CardTitle className="d-flex justify-content-between">
        <h6 className="dim-title">{dimension.name}</h6>

        <SelectedDropdown
          dimensionId={dimension.id}
          members={dimension.members}
          setMemberSelection={setMemberSelection}
        />
      </CardTitle>

      <MemberSelector
        dimensionId={dimension.id}
        members={dimension.members}
        setMemberSelection={setMemberSelection}
      />
    </Card>
  );
}

export default DimensionBox;
